import React, { useContext, useEffect } from 'react'
import { Context } from "../context/Context"
import { prayerAlert } from "../Database/Database"
import { Link } from "react-router-dom";
import axios from 'axios';
import { useState } from 'react';
import { base, getHeaders } from '../Config';
import moment from 'moment';
import { SendGuiDataEvents } from '../lib/CommonScript';

function Quran() {

  const { lang, theme, handleShowLoader } = useContext(Context);
  const [prayerDetails, setprayerDetails] = useState();
  const [showBtn,setShowBtn] = useState({
    btnOne : null,
    btnTwo : null
  });

  // handle previous path
  // useEffect(() =>{
  //   localStorage.setItem("prevPath","prayer_alert");
  // },[])

  const [currentDate, setCurrentDate] = useState(moment().format('DD-MM-YYYY'));


  function HandleSalatDates(value) {
    if (value === 'back' ) {
      let prevDate = moment(currentDate, 'DD-MM-YYYY').subtract(1, 'days').format('DD-MM-YYYY')
      if (prayerDetails[prevDate]) {
        setCurrentDate(prevDate);
      }
    } else {
      let nextDate = moment(currentDate, 'DD-MM-YYYY').add(1, 'days').format('DD-MM-YYYY')
      if (prayerDetails[nextDate]) {
        setCurrentDate(nextDate)
      }
    }
  }
  console.log("currentDate", currentDate);

  const getPrayerAlert = () => {
    handleShowLoader(true)
    axios({
      method: 'post',
      url: base + "salatTimings",
      data: { "date": currentDate },
      headers: getHeaders()
    }
    ).then((resp) => {
      console.log("prayer alert response ----> ", resp.data)
      setShowBtn({
        btnOne : Object.keys(resp.data)[1],
        btnTwo :Object.keys(resp.data)[Object.keys(resp.data).length -1]
      })

      setprayerDetails(resp.data)
      handleShowLoader(false)
    }).catch((error) => {
      console.log("error -----> ", error)
    })
  }

  useEffect(
    () => {
      localStorage.setItem("prevPath", "prayer_alert");
    }, [])

  useEffect(getPrayerAlert, [])


  const forwardIcon = require("../assets/red/next_page_arrow.png");
  const backIcon = require("../assets/red/back_page_arrow.png");

  console.log("show btn obj", showBtn)

  useEffect(() => {
    //send gui events
    let guiDataEvent = {};
    guiDataEvent["w_action"] = "card_click";
        guiDataEvent["name"] = "prayer_alert";
    SendGuiDataEvents(guiDataEvent);
  }, []);



  return (
    <div className={`min-h-screen h-full bg-cover ${theme === "red" ? " bg-red_bg_pic" : " bg-prayer_alert_bg"} bg-center bg-no-repeat  pt-20 max-width`}>
      <div className='flex flex-col justify-between text-white w-11/12 mx-auto h-85v'>
        <div className={`${theme === 'red' ? "border-2 border-brownBg" : ""} p-2 mt-10`}>
          <div className={`py-2 flex ${theme === "red" ? "bg-prayerAlertGrad-primary" : "bg-brownBg"}`}>
            { <div className={`my-auto pl-2 ${showBtn.btnOne === currentDate ? "opacity-20" : " "}`}><img style={{ width: "2rem" }} onClick={() => HandleSalatDates("back")} src={backIcon} /></div>}
            <div className='my-auto mx-auto'>{currentDate}</div>
            { <div className={`my-auto pr-2 ${showBtn.btnTwo === currentDate ? "opacity-20" : " "}`}><img style={{ width: "2rem" }} onClick={() => HandleSalatDates("forward")} src={forwardIcon} /></div>}
          </div>
          <div className='py-4'>
            {
              prayerDetails && prayerDetails[currentDate] && prayerDetails[currentDate].map((data, index) => {
                return (
                  <div className={`flex flex-row justify-between ${theme === "red" ? "bg-redThemePrimaryRedColor" : " bg-brownBg"} py-2 border-b px-4 text-sm`} key={index}>
                    <div >{data.heading}</div>
                    <div >{data.name}</div>
                    <div >{data.time}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quran